import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToShiftHoursPipe } from './to-shift-hours.pipe';
import { EmploymentTypePipe } from './employment-type.pipe';
import { StaffTypePipe } from './staff-type.pipe';
import { SecurePipe } from './secure.pipe';
import { BooleanToStringPipe } from './booleanToString.pipe';
import { ShiftTimeFormatPipe } from './shift-time-format.pipe';

@NgModule({
  declarations: [
    ToShiftHoursPipe,
    EmploymentTypePipe,
    StaffTypePipe,
    SecurePipe,
    BooleanToStringPipe,
    ShiftTimeFormatPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ToShiftHoursPipe,
    EmploymentTypePipe,
    StaffTypePipe,
    SecurePipe,
    BooleanToStringPipe,
    ShiftTimeFormatPipe
  ]
})
export class PipesModule {
}
